import { render, staticRenderFns } from "./AnnotationContent.vue?vue&type=template&id=64450ddc&scoped=true&"
import script from "./AnnotationContent.vue?vue&type=script&lang=js&"
export * from "./AnnotationContent.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=64450ddc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64450ddc",
  null
  
)

export default component.exports